import { formatCurrency } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ListingFormComponent } from '../listing-form/listing-form.component';

@Component({
  selector: 'app-add-listing-page',
  templateUrl: './add-listing-page.component.html',
  styleUrls: ['./add-listing-page.component.css']
})
export class AddListingPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
